import type { FallbackRender } from "@sentry/react"
import { showReportDialog } from "@sentry/react"
import { useNavigate } from "@tanstack/react-router"
import { Button, Glyph, Golden } from "@motleyhand/design"

type Props = Parameters<FallbackRender>[0]

export default function ErrorDisplay({ eventId }: Props) {
  const navigate = useNavigate()

  return (
    <Golden className="fixed inset-0 bg-background">
      <div className="flex max-w-sm flex-col items-center gap-6 px-6 text-center">
        <Glyph variant="dropped-catch" size={80} />
        <div className="flex flex-col gap-2">
          <h1 className="font-title text-2xl font-semibold tracking-tight">
            Oops, We Dropped One
          </h1>
          <p className="text-sm text-muted-foreground">
            This shouldn’t have happened. And yet, here we are.
          </p>
        </div>
        <div className="flex items-center gap-3">
          <Button
            variant="secondary"
            onClick={() => {
              showReportDialog({ eventId })
            }}
          >
            Tell Us What You Saw
          </Button>
          <span className="text-xs text-muted-foreground">or</span>
          <Button
            variant="outline"
            onClick={() => navigate({ to: "/dashboard", reloadDocument: true })}
          >
            Go to Dashboard
          </Button>
        </div>
      </div>
    </Golden>
  )
}
